import request from 'store/common/utils';
export const syncAmenitiesApi = (projectId, data) => request({
    url: `projects/${projectId}/amenities/sync`,
    method: 'POST',
    data,
});
